import { Accordion, AccordionDetails, AccordionSummary, Avatar, Box, Chip, Grid, Link, Typography } from "@mui/material";
import { formatPhoneNumber } from "../../common/component/util";
import { STORAGE_BUCKET } from "../../common/component/constants";
import moment from "moment";
import { ExpandMoreOutlined } from "@mui/icons-material";

export default function ThirdPartyDelivery(props) {
  const { provider } = props;
  if (provider) {
    const delivery = provider.data;
    return (
      <Box p={2} sx={{ backgroundColor: "#F7F7F7" }}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography variant="overline" color="textSecondary">
              Delivery Provider
            </Typography>
            <Typography style={{ display: "flex", alignItems: "center", fontSize: ".9em", gap: "5px" }}>
              <Avatar style={{ width: "48px", height: "48px" }} src={`${STORAGE_BUCKET}/img/logo/${provider.name.toLowerCase()}.webp`}></Avatar>
              { delivery?.status && <Chip label={delivery.status} /> }
            </Typography>
            {!provider.deliveryId && (
              <Typography color="error" variant="caption">
                Delivery Not Created!
              </Typography>
            )}
          </Grid>
          {delivery?.driver?.phone && (
            <Grid item xs={6}>
              <Box>
                <Typography variant="overline" color="textSecondary">
                  DRIVER
                </Typography>
                {delivery?.driver && delivery?.driver?.phone ? (
                  <Box>
                    <Typography variant="body2">{delivery.driver.name}</Typography>
                    <Typography variant="body2">{formatPhoneNumber(delivery.driver.phone)}</Typography>
                  </Box>
                ) : (
                  <Box>
                    <Typography variant="body2">Not yet assigned</Typography>
                    <Typography variant="caption" color="textSecondary">
                      Note: drivers are typically assigned within 24 hours of the scheduled pickup
                    </Typography>
                  </Box>
                )}
              </Box>
            </Grid>
          )}
        </Grid>
        {delivery && delivery.pickup && (
          <Box my={2}>
            <Grid container spacing={2}>
              <Grid item sm={6} xs={12}>
                <Box>
                  <Typography variant="overline" color="textSecondary">
                    PICKUP
                  </Typography>
                </Box>
                <Typography variant="h6" gutterBottom>{delivery.pickup.name}</Typography>
                <Typography variant="body2">{delivery.pickup.location.address}</Typography>
                {delivery.pickup.time.eta && (
                  <Typography variant="overline" display="block" gutterBottom>
                    {moment(delivery.pickup.time.eta).format("ddd MMM D, h:mm a")} (estimate)
                  </Typography>
                )}
                {delivery.pickup.time.actual && (
                  <Typography variant="overline" display="block" gutterBottom>
                    {moment(delivery.pickup.time.actual).format("ddd MMM D, h:mm a")} (actual)
                  </Typography>
                )}
              </Grid>
              <Grid item sm={6} xs={12}>
                <Box>
                  <Box>
                    <Typography variant="overline" color="textSecondary">
                      DROPOFF
                    </Typography>
                  </Box>
                  <Typography variant="h6" gutterBottom>{delivery.dropoff.name}</Typography>
                  <Typography variant="body2">{formatPhoneNumber(delivery.dropoff.phone)}</Typography>
                  <Typography variant="body2">{delivery.dropoff.location.address}</Typography>
                  {delivery.dropoff.time.eta && (
                    <Typography variant="overline" display="block" gutterBottom>
                      {moment(delivery.dropoff.time.eta).format("ddd MMM D, h:mm a")} (estimate)
                    </Typography>
                  )}
                  {delivery.dropoff.time.actual && (
                    <Typography variant="overline" display="block" gutterBottom>
                      {moment(delivery.dropoff.time.actual).format("ddd MMM D, h:mm a")} (actual)
                    </Typography>
                  )}
                  {delivery.dropoff?.trackingLink && (
                    <Box>
                      <Link component="a" target="_blank" href={delivery.dropoff.trackingLink}>
                        Tracking Link
                      </Link>
                    </Box>
                  )}
                </Box>
              </Grid>
            </Grid>
          </Box>
        )}
        <Accordion elevation={0}>
          <AccordionSummary expandIcon={<ExpandMoreOutlined />}>API Response</AccordionSummary>
          <AccordionDetails>
            <pre style={{ fontSize: "10px", color: "#FFF", backgroundColor: "#000" }}>{JSON.stringify(provider.data, null, 2)}</pre>
          </AccordionDetails>
        </Accordion>
      </Box>
    );
  } else {
    return <></>;
  }
}
